// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__I1buK","logoTitle":"footer_logoTitle__1N-kt","links":"footer_links__1Zqfq","copyright":"footer_copyright__2ldIK"};